/**
 * Pure helpers for the product-order feature (no I/O, no economic computation).
 */

/**
 * Generate a fresh idempotency key for an order-creation attempt.
 *
 * Prefers the platform ``crypto.randomUUID`` (available in Mini App webviews); falls back
 * to a time+random token when unavailable (older test environments). The key only needs to
 * be unique per attempt — the server enforces idempotency via Redis SETNX + a DB unique
 * constraint.
 */
export function newIdempotencyKey(): string {
  const c: Crypto | undefined =
    typeof globalThis.crypto !== "undefined" ? globalThis.crypto : undefined;
  if (c !== undefined && typeof c.randomUUID === "function") {
    return c.randomUUID();
  }
  const rand = Math.random().toString(36).slice(2);
  return `ord-${Date.now().toString(36)}-${rand}`;
}

/** Parse a free-text currency-spend field into a non-negative integer (0 on garbage). */
export function parseSpend(raw: string): number {
  const value = Math.trunc(Number(raw));
  return Number.isFinite(value) && value > 0 ? value : 0;
}

/** Stable signature of a quote/order attempt (drives the idempotency key). */
export function attemptKey(
  productId: number,
  starGlitterSpend: number,
  primogemSpend: number,
): string {
  return `${productId}:${starGlitterSpend}:${primogemSpend}`;
}
